import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import { numberFormatterInternational } from 'app/utils/telephonyHelpers';
import { flowNodeColor } from 'fable/flowEditor';
import { hexStringToNumber } from 'fable/flowEditor/components/flowManager/canvas/renderers/common/colors';
import { Text } from 'flow-builder/node/text';
import { TextContent } from 'flow-builder/node/textContent';
import { TextEllipsis } from 'flow-builder/node/textEllipsis';
export const createInitNode = (getDisplayName) => function InitNode(props) {
    const { context } = props;
    const { extraData } = context;
    const name = getDisplayName(extraData);
    return (_jsx(TextContent, { children: useMemo(() => (_jsxs(TextEllipsis, { children: [_jsx(Text, { weight: "normal", text: "To" }), _jsx(Text, { weight: "semibold", text: name })] })), [name]) }));
};
export const createInitNodeAttributes = (attributes, getDisplayName) => (Object.assign({ color: hexStringToNumber(flowNodeColor.default), translatePayload: ({ children: [child] }) => [
        { id: uuid(), connection: child || uuid(), label: 'arrow' },
    ], updateConnection: (node) => node, NodeContent: createInitNode(getDisplayName) }, attributes));
export const InitNodeChatAttributes = createInitNodeAttributes({
    iconName: 'chat',
    label: 'Incoming chat',
}, (data) => data.name || 'Name your flow');
export const InitNodeEmailAttributes = createInitNodeAttributes({
    iconName: 'chat',
    label: 'Incoming email',
}, (data) => data.name || 'Name your flow');
export const InitNodePhoneAttributes = createInitNodeAttributes({
    iconName: 'phone',
    label: 'Incoming call',
}, (data) => {
    const { number } = data;
    const isNumberSet = number !== 'local';
    return isNumberSet
        ? numberFormatterInternational({ phoneNumber: number })
        : 'No number selected';
});
export const InitNodeMessengerAttributes = createInitNodeAttributes({
    iconName: 'messenger',
    label: 'Incoming chat',
}, (data) => data.name || 'Untitled');
